var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:( _obj = {}, _obj[_vm.classActive] = _vm.inView, _obj[_vm.classInactive] = !_vm.inView, _obj )},'div',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }